document.addEventListener("DOMContentLoaded", function () {
	console.log("Script de programação carregado")

	const filterButtons = document.querySelectorAll(".programacao__filter-btn")
	const programacaoGrid = document.querySelector(".programacao__grid")
	const searchInput = document.querySelector(".programacao__search-input")
	const searchButton = document.querySelector(".programacao__search-button")
	let currentDay = "1" // Segunda-feira como padrão
	let searchTerm = ""

	if (!filterButtons.length || !programacaoGrid) return

	// Função para fazer a requisição AJAX
	function fetchPrograms(day, search = "") {
		fetch(programacaoAjax.ajaxurl, {
			method: "POST",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
			},
			body: new URLSearchParams({
				action: "filter_programacao",
				day: day,
				search: search,
				nonce: programacaoAjax.nonce,
			}),
		})
			.then((response) => response.text())
			.then((html) => {
				programacaoGrid.innerHTML = html
			})
	}

	// Função para filtrar programas
	function filterPrograms() {
		const programs = document.querySelectorAll(".programa-card")

		programs.forEach((program) => {
			const title = program.querySelector(".programa-card__title").textContent.toLowerCase()
			const day = program.getAttribute("data-day")

			const matchesDay = currentDay === "all" || day === currentDay
			const matchesSearch = title.includes(searchTerm.toLowerCase())

			program.style.display = matchesDay && matchesSearch ? "block" : "none"
		})

		// Mostra mensagem de vazio se não houver programas visíveis
		const visiblePrograms = document.querySelectorAll(".programa-card[style='display: block']")
		const emptyMessage = document.querySelector(".programacao__empty")

		if (visiblePrograms.length === 0) {
			if (!emptyMessage) {
				const emptyDiv = document.createElement("div")
				emptyDiv.className = "programacao__empty"
				emptyDiv.textContent = "Nenhuma programação encontrada para este dia."
				programacaoGrid.appendChild(emptyDiv)
			}
		} else if (emptyMessage) {
			emptyMessage.remove()
		}
	}

	// Event listeners para os botões de filtro
	filterButtons.forEach((button) => {
		button.addEventListener("click", function () {
			const day = this.getAttribute("data-day")

			// Remove classe ativa de todos os botões
			filterButtons.forEach((btn) => btn.classList.remove("is-active"))
			// Adiciona classe ativa ao botão clicado
			this.classList.add("is-active")
			currentDay = day

			// Faz a requisição AJAX para buscar os programas do dia, mantendo o termo de busca atual
			fetchPrograms(currentDay, searchTerm)
		})
	})

	// Event listener para busca (ao digitar)
	searchInput.addEventListener("input", (e) => {
		searchTerm = e.target.value
		fetchPrograms(currentDay, searchTerm)
	})

	// Event listener para busca (ao clicar no botão)
	searchButton.addEventListener("click", (e) => {
		e.preventDefault()
		searchTerm = searchInput.value
		fetchPrograms(currentDay, searchTerm)
	})

	// Inicializar com os programas da segunda-feira
	fetchPrograms(currentDay)
})
